module.exports = __webpack_public_path__ + "static/media/edit.fe4332d9.svg";